var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"boxes"},[_c('h3',[_c('Icon',{attrs:{"type":"md-bookmarks"}}),_vm._v("报警级别分析"),_vm._t("right")],2),_vm._v(" "),_c('Table',{attrs:{"data":_vm.tableData,"columns":_vm.columns},scopedSlots:_vm._u([{key:"alarmLevel",fn:function(ref){
var row = ref.row;
return [(row.alarmLevel === 1)?_c('span',[_vm._v("一级报警")]):(row.alarmLevel === 2)?_c('span',[_vm._v("二级报警")]):(row.alarmLevel === 3)?_c('span',[_vm._v("三级报警")]):_vm._e()]}},{key:"alarmTotal",fn:function(ref){
var row = ref.row;
return [_c('span',[_vm._v(_vm._s(row.alarmTotal)+"次")])]}},{key:"carTotal",fn:function(ref){
var row = ref.row;
return [_c('span',[_vm._v(_vm._s(row.carTotal)+"辆")])]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65e141d0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dataAnalyse/anaReports/baojingjibie.vue
// module id = null
// module chunks = 